import React, { useEffect, useMemo } from 'react';

const ANDROID_STORE_URL =
  process.env.REACT_APP_ANDROID_STORE_URL || 'https://play.google.com/store';
const IOS_STORE_URL = process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com/';

function pushEvent(event, params = {}) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event, ...params });
  }
}

function getStoreTarget() {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('android')) return 'android';
  if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) return 'ios';
  return 'desktop';
}

export default function StoreSmartLinkPage() {
  const target = useMemo(() => getStoreTarget(), []);

  useEffect(() => {
    if (target === 'android') {
      pushEvent('cta_store_click', { source: 'smart_link', target: 'android' });
      window.location.replace(ANDROID_STORE_URL);
      return;
    }
    if (target === 'ios') {
      pushEvent('cta_store_click', { source: 'smart_link', target: 'ios' });
      window.location.replace(IOS_STORE_URL);
    }
  }, [target]);

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16">
      <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-2xl font-bold text-slate-900">Telecharger OuiGoo</h1>
        <p className="mt-3 text-sm text-slate-600">Choisissez votre plateforme.</p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <a
            href={ANDROID_STORE_URL}
            onClick={() => pushEvent('cta_store_click', { source: 'desktop_select', target: 'android' })}
            className="rounded-xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
          >
            Google Play
          </a>
          <a
            href={IOS_STORE_URL}
            onClick={() => pushEvent('cta_store_click', { source: 'desktop_select', target: 'ios' })}
            className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-100"
          >
            App Store
          </a>
        </div>
      </div>
    </main>
  );
}

